<template>
  <div
    class="bg-white overflow-auto padding-five-all margin-top-ten gestor-centralizado-table"
  >
    <b-container fluid class="px-0">
      <b-row>
        <b-col cols="12">
          <h5 class="color-orange">{{ messages.SECTION_TITLE }}</h5>
        </b-col>
      </b-row>

      <b-row v-if="loadError">
        <b-col cols="12">
          <b-alert show variant="danger" class="mb-3">
            {{ loadError }}
          </b-alert>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-table
            class="table-fixed"
            show-empty
            :empty-text="messages.EMPTY_TABLE"
            small
            striped
            hover
            responsive
            :busy="loading"
            :items="items"
            :fields="tableFields"
          >
            <template #table-busy>
              <div class="text-center text-danger my-3">
                <b-spinner class="align-middle mr-2" />
                <strong>{{ messages.LOADING }}</strong>
              </div>
            </template>

            <template #cell(montoOcSinIgv)="{ value }">
              {{ formatMoney(value) }}
            </template>

            <template #cell(indicadorImputacion)="{ value }">
              {{ value || "-" }}
            </template>

            <template #cell(material)="{ value }">
              {{ value || "-" }}
            </template>

            <template #cell(indicarTextoOc)="{ value }">
              {{ value || "-" }}
            </template>

            <template #cell(centroDeCostos)>
              Retail
            </template>

            <template #cell(numeroOc)="{ value }">
              {{ value || "-" }}
            </template>

            <template #cell(migo)="{ value }">
              {{ value || "-" }}
            </template>

            <template #cell(archivoPdf)="{ item }">
              <a
                v-if="item.urlPdf"
                :href="item.urlPdf"
                target="_blank"
                rel="noopener noreferrer"
                class="btn btn-sm btn-link p-0 text-danger font-weight-bold"
                title="Ver PDF de la OC"
              >
                <font-awesome-icon icon="file-pdf" class="mr-1" />
                PDF
              </a>
              <span v-else class="text-muted">-</span>
            </template>

            <template #cell(status)="{ item }">
              <button
                type="button"
                class="operaciones-status-trigger"
                :disabled="item.estadoOc === 'COMPLETADO'"
                @click="
                  item.estadoOc !== 'COMPLETADO' && $emit('edit-status', item)
                "
              >
                <span>{{ getStatusLabel(item.estadoOc) }}</span>
                <font-awesome-icon
                  v-if="item.estadoOc !== 'COMPLETADO'"
                  icon="pen"
                  class="operaciones-status-trigger__icon"
                />
              </button>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row v-if="showPagination && totalRows > perPage">
        <b-col cols="12">
          <b-pagination
            :value="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            align="center"
            size="md"
            class="my-3 gestor-centralizado-pagination"
            @input="$emit('update:currentPage', $event)"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { formatMoney } from "@/services/gestor-centralizado/gestor-centralizado.formatters";
import {
  getOperacionesEstadoLabel,
  getOperacionesTableFields,
  MESSAGES,
} from "@/services/operaciones/operaciones.constants";

export default {
  name: "OperacionesTable",

  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    loadError: { type: String, default: "" },
    currentPage: { type: Number, default: 1 },
    perPage: { type: Number, default: 10 },
    totalRows: { type: Number, default: 0 },
    showPagination: { type: Boolean, default: true },
  },

  data() {
    return {
      messages: MESSAGES,
      tableFields: getOperacionesTableFields(),
    };
  },

  methods: {
    formatMoney,
    getStatusLabel: getOperacionesEstadoLabel,
  },
};
</script>
